import SectionCard from '../shared/SectionCard'
import { Stack } from './styled-components'
import CommunicationBoardForm from '@/containers/DevToolsNew/CommunicationBoard/CommunicationBoardForm'

const CommunicationBoardPage = () => {
  return (
    <Stack>
      <SectionCard>
        <CommunicationBoardForm />
      </SectionCard>
    </Stack>
  )
}

export default CommunicationBoardPage
